module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px:height: auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("NEW REVERSE TALLY")])], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "dateRange"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "opens": _vm.openRight,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    on: {
      "update": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateRange", $$v)
      },
      expression: "Filter.dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Vendor")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllTallyVendorList'],
      "id": "branchFilter",
      "option-value": "label",
      "option-text": "label",
      "placeholder": "Select Vendor",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.vendor_nameFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "vendor_nameFilter", $$v)
      },
      expression: "Filter.vendor_nameFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Vendor GST")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllTallyVendorGstList'],
      "id": "branchFilter",
      "option-value": "vendor_add_Gstin",
      "option-text": "vendor_add_Gstin",
      "placeholder": "Select Vendor GST",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.vendor_gstFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "vendor_gstFilter", $$v)
      },
      expression: "Filter.vendor_gstFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientName"
    }
  }, [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientName",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.clientIdFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientIdFilter", $$v)
      },
      expression: "Filter.clientIdFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POR")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPORList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Place of Receipt"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      },
      "update": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.PORFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PORFilter", $$v)
      },
      expression: "Filter.PORFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPODList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Port of Discharge"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      },
      "update": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.PODFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PODFilter", $$v)
      },
      expression: "Filter.PODFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Container Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllContainerTypeList'],
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container Type"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.containerTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "containerTypeFilter", $$v)
      },
      expression: "Filter.containerTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.SlineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "SlineFilter", $$v)
      },
      expression: "Filter.SlineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Air Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllAirLineList'],
      "option-value": "airlineId",
      "option-text": "airlineName",
      "placeholder": "Select Air Line"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.airLineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "airLineFilter", $$v)
      },
      expression: "Filter.airLineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Expense No.")]), _vm._v(" "), _c('b-form-input', {
    staticClass: "mt-2",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Expense Number"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.InvoiceNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "InvoiceNoFilter", $$v)
      },
      expression: "Filter.InvoiceNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Assignment No.")]), _vm._v(" "), _c('b-form-input', {
    staticClass: "mt-2",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": " Assignment No."
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.assignmentFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "assignmentFilter", $$v)
      },
      expression: "Filter.assignmentFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Common Search.")]), _vm._v(" "), _c('b-form-input', {
    staticClass: "mt-2",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Common BL/Container Search"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.CommonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "CommonFilter", $$v)
      },
      expression: "Filter.CommonFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Expense Status")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "mt-2",
    attrs: {
      "list": _vm.invoiceStatusdataList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Status"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.invstatusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "invstatusFilter", $$v)
      },
      expression: "Filter.invstatusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.branchFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchFilter", $$v)
      },
      expression: "Filter.branchFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 pull-right",
    attrs: {
      "md": "3"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "font-size": "0.675rem margin-left: auto"
    },
    attrs: {
      "size": "sm",
      "variant": "danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v(" Reset & Close\n\t\t\t\t\t\t")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "info"
    }
  }, [_c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [_c('b-button-group', {
    staticClass: "m2-1 text-right",
    attrs: {
      "size": "sm"
    }
  }, [_c('b-button', {
    class: 'ml-4' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.dateRange.startDate ||
        _vm.Filter.dateRange.endDate ||
        _vm.Filter.vendor_nameFilter ||
        _vm.Filter.vendor_gstFilter ||
        _vm.Filter.clientIdFilter ||
        _vm.Filter.PORFilter ||
        _vm.Filter.PODFilter ||
        _vm.Filter.containerTypeFilter ||
        _vm.Filter.SlineFilter ||
        _vm.Filter.airLineFilter ||
        _vm.Filter.InvoiceNoFilter ||
        _vm.Filter.assignmentFilter ||
        _vm.Filter.CommonFilter ||
        // Filter.invstatusFilter ||
        _vm.Filter.branchFilter ?
        'danger' :
        'primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.Filter.dateRange.startDate ||
    _vm.Filter.dateRange.endDate ||
    _vm.Filter.vendor_nameFilter ||
    _vm.Filter.vendor_gstFilter ||
    _vm.Filter.clientIdFilter ||
    _vm.Filter.PORFilter ||
    _vm.Filter.PODFilter ||
    _vm.Filter.containerTypeFilter ||
    _vm.Filter.SlineFilter ||
    _vm.Filter.airLineFilter ||
    _vm.Filter.InvoiceNoFilter ||
    _vm.Filter.assignmentFilter ||
    _vm.Filter.CommonFilter ||
    // Filter.invstatusFilter ||
    _vm.Filter.branchFilter ?
    "Filter ON" :
    "Filter OFF") + "\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("Back")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [(_vm.rerverseTallyList.length > 0) ? _c('b-button', {
    staticClass: "pull-left mb-1",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('Expense_BILLING', 'Export As Excel')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.ExcelBtnName) + "\n\t\t\t\t\t\t"), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('h5', {
    staticClass: "text-muted pull-right mt-2"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.rerverseTallyList,
      "responsive": "",
      "fields": _vm.expenseFields,
      "primary-key": "tally_bill_exp_id",
      "per-page": _vm.pagination.perPage,
      "current-page": _vm.pagination.currentPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "tally_bill_exp_id",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage))])]
      }
    }, {
      key: "vendorName",
      fn: function(row1) {
        return [_c('span', [_vm._v("Name : " + _vm._s(row1.item.vendorName)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("GST : " + _vm._s(row1.item.vendorGST)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Add : " + _vm._s(row1.item.vendorAdd)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("State : " + _vm._s(row1.item.vendorState)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("GST Code : " + _vm._s(row1.item.vendorStateCode))])]
      }
    }, {
      key: "buyerName",
      fn: function(row2) {
        return [_c('span', [_vm._v("Name : " + _vm._s(row2.item.buyerName)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("GST : " + _vm._s(row2.item.buyerGST)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Add : " + _vm._s(row2.item.buyerAdd)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("State : " + _vm._s(row2.item.buyerState)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("GST Code : " + _vm._s(row2.item.buyerStateCode))])]
      }
    }, {
      key: "fk_all_module_id",
      fn: function(row3) {
        return [_c('span', [_vm._v("Ass.No : " + _vm._s(row3.item.AssNo)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Ass.Date : " + _vm._s(row3.item.AssDate)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Raised From : " + _vm._s(row3.item.RasiedFrom)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Raised By : " + _vm._s(row3.item.RaisedBy)), _c('br')])]
      }
    }, {
      key: "destination",
      fn: function(row4) {
        return [_c('span', [_vm._v("POR : " + _vm._s(row4.item.POR)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("POL : " + _vm._s(row4.item.POL)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("POD : " + _vm._s(row4.item.POD)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("FPOD : " + _vm._s(row4.item.FPOD)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Client : " + _vm._s(row4.item.clientName)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Sline : " + _vm._s(row4.item.shippingLine)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("MBLNO : " + _vm._s(row4.item.MBLNO)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("HBLNO : " + _vm._s(row4.item.HBLNO)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("SOB : " + _vm._s(row4.item.SOB)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Vessel : " + _vm._s(row4.item.vessel_voyage))])]
      }
    }, {
      key: "status",
      fn: function(row5) {
        return [(row5.item.ManualStatus != '' && row5.item.ManualStatus != null) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\tManual Status :\n\t\t\t\t\t\t\t\t"), (row5.item.ManualStatus == 'Active') ? _c('span', {
          style: (row5.item.ManualStatus ? 'color: green' : 'color: red')
        }, [_vm._v(_vm._s(row5.item.ManualStatus))]) : _vm._e()]) : _vm._e(), _c('br'), _vm._v(" "), (row5.item.status != '' && row5.item.status != null) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\tExpense Status :\n\t\t\t\t\t\t\t\t"), (row5.item.status == 'Active') ? _c('span', {
          style: (row5.item.status ? 'color: green' : 'color: red')
        }, [_vm._v(_vm._s(row5.item.status))]) : _vm._e()]) : _vm._e(), _c('br')]
      }
    }, {
      key: "docDtls_No",
      fn: function(row6) {
        return [_c('span', [_vm._v("Exp No :\n\t\t\t\t\t\t\t\t"), _c('b-button', {
          staticClass: "mt-1",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "variant": "outline-info",
            "size": "xs"
          },
          on: {
            "click": function($event) {
              _vm.goExpenseDet(row6.item)
            }
          }
        }, [_vm._v(_vm._s(row6.item.docDtls_No))]), _c('br')], 1), _vm._v(" "), _c('span', [_vm._v("Exp Type : " + _vm._s(row6.item.docDtls_Typ)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Exp Date : " + _vm._s(row6.item.Exp_Date)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Container : " + _vm._s(row6.item.ExpContainersNo)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("System Container : "), _c('br')]), _vm._v(" "), (row6.item.AssContainerNos) ? _c('div', {
          staticClass: "text-left"
        }, [(row6.item.AssContainerNos) ? _c('div', _vm._l((row6.item.AssContainerNos.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 == "" ? "-------" : item1) + "\n\t\t\t\t\t\t\t\t\t\t\t")])], 1)])
        })) : _vm._e()]) : _c('div', {
          staticClass: "text-left"
        }, [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1), _vm._v(" "), _c('span', [_vm._v("System Container Type : " + _vm._s(row6.item.containerType)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Updated Date : " + _vm._s(row6.item.ExpUpdateDate)), _c('br')]), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row6.item)
            }
          }
        }, [_vm._v("Summary & Documents")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking - ',
            "fk_all_module_id": row6.item.fk_all_module_id,
            "jb_series": row6.item.ExpjobNo
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": ""
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "8",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e3b031b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/vehicleQuotation/newReverseTally.vue
// module id = 2732
// module chunks = 0